import * as React from 'react';
import {
  StyleSheet,
  Pressable,
  ImageSourcePropType,
  Image,
  View
} from 'react-native';
import { translate } from 'secullum-i18n';
import { getTheme, Space, Text } from 'secullum-react-native-ui';
import { Amarelo100, Cinza100 } from '../../modules/layout';
import { montarRespostas } from '../../modules/qualidadeVidaTrabalho';
import {
  QualidadeVidaTrabalho,
  TipoRespostaQualidadeVidaTrabalho
} from '../../modules/types';

interface QualidadeVidaTrabalhoOpcoesWebProps {
  dados: QualidadeVidaTrabalho;
  onConcluir: (resposta: TipoRespostaQualidadeVidaTrabalho) => void;
}

interface State {
  dadosDescricao: {
    cor: string;
    titulo: string;
    descricao: string;
  };
}

interface QualidadeVidaTrabalhoOpcaoProps {
  text: string;
  image: ImageSourcePropType;
  nativeID: string;
  onPress: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

function QualidadeVidaTrabalhoOpcao({
  text,
  image,
  nativeID,
  onPress,
  onMouseEnter,
  onMouseLeave
}: QualidadeVidaTrabalhoOpcaoProps) {
  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => [styles.opcao, { opacity: pressed ? 0.7 : 1 }]}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Image
          nativeID={`${nativeID}-imagem`}
          style={styles.opcaoImagem}
          source={image}
        />
        <Text nativeID={`${nativeID}-texto`} style={styles.opcaoText}>
          {text}
        </Text>
      </div>
    </Pressable>
  );
}

class QualidadeVidaTrabalhoOpcoesWeb extends React.Component<QualidadeVidaTrabalhoOpcoesWebProps> {
  state: State = {
    dadosDescricao: {
      cor: 'transparent',
      descricao: '',
      titulo: ''
    }
  };

  handleLimparHover = () => {
    this.setState({
      dadosDescricao: {
        cor: 'transparent',
        descricao: '',
        titulo: ''
      }
    });
  };

  render() {
    const { dados, onConcluir } = this.props;
    const { dadosDescricao } = this.state;

    return (
      <View style={styles.container}>
        <Text
          nativeID="qvt-pergunta"
          size={30}
          align="center"
          style={styles.perguntaText}
        >
          {dados.pergunta}
        </Text>
        <Space />
        <View style={styles.opcoesContainer}>
          {montarRespostas(dados).map(resposta => (
            <QualidadeVidaTrabalhoOpcao
              key={resposta.sufixoId}
              nativeID={`qvt-resposta-${resposta.sufixoId}`}
              text={resposta.texto}
              image={resposta.imagem}
              onPress={() => onConcluir(resposta.tipo)}
              onMouseEnter={() =>
                this.setState({
                  dadosDescricao: {
                    cor: resposta.cor,
                    titulo: resposta.texto,
                    descricao: resposta.descricao
                  }
                })
              }
              onMouseLeave={this.handleLimparHover}
            />
          ))}
        </View>
        <Space />
        <View
          style={[styles.imagemHover, { backgroundColor: dadosDescricao.cor }]}
        >
          <Text
            nativeID="qvt-detalhe-resposta-titulo"
            size={20}
            align="center"
            bold
            color={theme.backgroundColor2}
          >
            {dadosDescricao.titulo}
          </Text>
          <Space />
          <Text
            nativeID="qvt-detalhe-resposta-descricao"
            size={15}
            align="center"
            color={theme.backgroundColor2}
          >
            {dadosDescricao.descricao}
          </Text>
        </View>
        <Space />
        <Pressable
          style={({ pressed }) => [
            { opacity: pressed ? 0.7 : 1 },
            styles.linkContainer
          ]}
          onPress={() =>
            onConcluir(TipoRespostaQualidadeVidaTrabalho.NaoRespondeu)
          }
        >
          <Text nativeID="qvt-nao-responder" style={styles.link}>
            {translate('Não responder')}
          </Text>
        </Pressable>
      </View>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    alignItems: 'center',
    alignContent: 'space-between',
    backgroundColor: theme.backgroundColor1,
    borderRadius: 6,
    maxWidth: '95%',
    width: 900,
    minHeight: 500,
    marginVertical: 'auto'
  },
  perguntaText: {
    paddingBottom: 20,
    paddingTop: 60,
    color: theme.textColor1,
    width: '90%'
  },
  linkContainer: {
    marginTop: 'auto'
  },
  link: {
    fontFamily: theme.fontFamily2,
    color: Cinza100,
    fontSize: 20,
    textDecorationLine: 'underline',
    textDecorationColor: Amarelo100,
    textAlign: 'center',
    paddingBottom: 20
  },
  opcoesContainer: {
    flexDirection: 'row',
    width: '100%',
    paddingHorizontal: 20,
    gap: 16
  },
  opcao: {
    flex: 1
  },
  opcaoText: {
    fontFamily: theme.fontFamily1,
    fontSize: 18,
    color: theme.textColor1,
    textAlign: 'center'
  },
  opcaoImagem: {
    width: 80,
    height: 80
  },
  imagemHover: {
    width: '100%',
    height: 150,
    justifyContent: 'center'
  }
});

export default QualidadeVidaTrabalhoOpcoesWeb;
